import * as React from 'react'
import { FormGroup, Input, InputGroupAddon } from 'reactstrap'
import { FormHelperText } from '@material-ui/core'
import TextareaAutosize from 'react-autosize-textarea'
import 'react-phone-number-input/style.css'

import RadioButton from '../../common/RadioButton/InlineRadio.web'
import LabeledSelect from '../../common/SelectField/SelectField.web'
import DatePicker from '../../common/DatePicker/DatePicker.web'
import Checkbox from '../../common/Checkbox/Checkbox.web'
import TimePicker from '../../common/TimePicker/TimePicker.web'
const PhoneInput = require('react-phone-number-input/input').default


interface InputTypeProps {
  fieldProps: any
  type: string
}

const InputType: React.FC<any> = props => {
  const fieldProps = { ...props.fieldProps }
  const {
    input,
    value,
    type,
    id,
    label,
    placeholder,
    options,
    defaultValue,
    pluginOptions,
    disabled,
    onSelect,
    onTextAreaChange
  } = props

  const onTextAreaInputChange = (
    event: React.FormEvent<HTMLTextAreaElement>
  ) => {
    // @ts-ignore
    onTextAreaChange(event.target.value)
  }
  switch (type) {
    case 'email':
    case 'text':
    case 'number':
    case 'password':
      return (
        <Input
          id={id}
          {...input}
          type={type}
          placeholder={placeholder}
          disabled={disabled}
          {...fieldProps}
        />
      )
    case 'select':
      return (
        <LabeledSelect
          defaultValue={defaultValue}
          label={label}
          options={options}
          onSelect={onSelect}
          className={`${fieldProps.className}`}
          disabled={disabled}
          placeholder={placeholder}
          onInputChange={pluginOptions ? pluginOptions.onInputChange : undefined}
          noDefault={pluginOptions ? pluginOptions.noDefault : undefined}
          noOptionsMessage={pluginOptions ? pluginOptions.noOptionsMessage : undefined}
          {...input}
        />
      )
    case 'radio':
      return (
        <RadioButton
          options={options}
          onChange={props.onChange}
          value={fieldProps.value}
          label={label}
        />
      )

    case 'checkboxgroup':
      return (
        <Checkbox
          input={input}
          options={options}
          label={label}
          onChange={props.onChange}
        />
      )
    case 'checkbox':
      return (
        <label className="m-0" >
          <Input
            name={`${input.name}`}
            type="checkbox"
            checked={input.value}
            onChange={(event: any) => {
              return props.onChange(event)
            }
            }
          />
          <span className="fa fa-check"></span>&nbsp;
        {pluginOptions.label}
        </label>
      )
    case 'timepicker':
      return <TimePicker onChange={props.onChange} classes={fieldProps.className} disabled={disabled} {...fieldProps} />
    case 'datepicker':
      return (
        <DatePicker
          onChange={props.onChange}
          value={value}
        />
      )
    case 'textArea':
      return (
        <TextareaAutosize
          className={` ${fieldProps.className}`}
          placeholder={placeholder}
          rows={fieldProps.rows}
          maxRows={fieldProps.maxrows}
          onChange={props.onChange}
          value={fieldProps.value}
        ></TextareaAutosize>
      )
    case 'phonenumber':
      return (
        <PhoneInput
          placeholder={placeholder}
          value={fieldProps.value}
          onChange={(phValue: string) => {
            if (!phValue) {
              props.onChange('')
            } else {
              props.onChange(phValue)
            }
          }}
          country={'US'}
          useNationalFormatForDefaultCountryValue={true}
          international={false}
          className={'form-control'}
        />)
    default:
      return <></>
  }
}

export const FormField = ({
  meta: { touched, error },
  input,
  type,
  id,
  label,
  icon,
  sublabel,
  addon,
  noLabel,
  placeholder,
  classes,
  options,
  styles,
  defaultValue,
  pluginOptions,
  disabled,
  note,
  onSelect,
  required,
  rows,
  maxrows,
  containerClasses,
  containerStyle,
  loading,
  className,
}: any) => {
  const fieldProps = {
    ...input,
    type,
    id,
    styles,
    rows,
    maxrows,
    placeholder: placeholder || (label ? label : ''),
    className: classes,
    invalid: !!(touched && error)
  }

  const isError = touched && error
  const errorMsg = type === 'email' || 'datepicker' ? error : `${label ? label : ''} ${error}`
  return (
    <>
      <FormGroup
        className={`labeledField ${
          type === 'checkbox' ? 'checkbox c-checkbox' : ''}  ${noLabel ? 'mt-3 mb-0 ' : ''} ${className ? className : ''}`}
      >
        {(label && type !== 'checkbox') && (
          <label className={`col-form-label`}>
            {label ? label : ' '}
            <span style={{ fontSize: 13, textTransform: 'lowercase' }} >
              {`${sublabel ? '(' + sublabel + ')' : ' '}`} &nbsp;
            </span>
            {required && <span className="text-danger">*</span>}
            {note ? <p className="mt-0" style={{ fontSize: 12, textTransform: 'lowercase', color: 'grey' }}>{note} </p> : null}

          </label>
        )}
        <div className={`${icon || addon ? 'input-group' : ''}  with-focus ${containerClasses} ${loading ? 'field-loading' : ''}`}
          style={containerStyle}>
          <InputType
            id="inlineFormInput"
            {...input}
            type={type}
            placeholder={placeholder}
            disabled={disabled}
            fieldProps={fieldProps}
            defaultValue={defaultValue}
            options={options}
            onSelect={onSelect}
            styles={styles}
            input={input}
            pluginOptions={pluginOptions}
          />
          {icon && (
            <div className="input-group-append">
              <span className={`input-group-text text-muted bg-transparent border-left-0 `}>
                <em className={`fa ${icon}`} />
              </span>
            </div>
          )}
          {addon && <InputGroupAddon addonType="append">{`${addon}`}</InputGroupAddon>}
          {loading && <em className="fas fa-circle-notch fa-spin ml-1" />}
        </div>
        {isError && (
          <div>
            {' '}
            <FormHelperText
              focused
              error
              className="font-12"
              variant="standard"
            >{errorMsg}</FormHelperText>
          </div>
        )}
      </FormGroup>
    </>
  )
}
